// Helpers timezone Europe/Paris.
// Le restaurant opère toujours en heure de Paris : on convertit en UTC à l'envoi
// et on force l'affichage en Europe/Paris, peu importe le fuseau du navigateur.

const PARIS = 'Europe/Paris';

// Date du jour en Europe/Paris, format 'YYYY-MM-DD' (en-CA donne YYYY-MM-DD).
// À utiliser partout au lieu de new Date().toISOString() qui donne la date UTC
// (fausse en soirée : après 22h/23h Paris, l'UTC est déjà le lendemain… ou la
// veille au petit matin).
export function parisTodayKey() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: PARIS }).format(new Date());
}

// Heure actuelle (0-23) en Europe/Paris.
export function parisHour() {
  return parseInt(
    new Intl.DateTimeFormat('en-GB', { timeZone: PARIS, hour: '2-digit', hour12: false }).format(new Date()),
    10
  );
}

// Objet Date (issu du DatePicker, en heure locale du navigateur) -> 'YYYY-MM-DD'
// selon les composants LOCAUX, c.-à-d. le jour réellement affiché/cliqué.
// Évite le décalage d'un jour de toISOString() (qui repasse en UTC).
export function dateToKey(d) {
  if (!d) return '';
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// 'YYYY-MM-DD' -> Date à midi local (pour DatePicker selected, sans décalage).
export function keyToDate(key) {
  return key ? new Date(`${String(key).slice(0, 10)}T12:00:00`) : null;
}

// 'YYYY-MM-DD' + n jours -> 'YYYY-MM-DD'
export function addDaysKey(key, n) {
  const d = keyToDate(key);
  d.setDate(d.getDate() + n);
  return dateToKey(d);
}

// 'YYYY-MM-DD' + 'HH:MM' interprétés comme heure murale Paris -> ISO UTC.
export function parisLocalToISO(dateStr, timeStr) {
  if (!dateStr || !timeStr) return null;
  const target = `${dateStr}T${timeStr.length === 5 ? `${timeStr}:00` : timeStr}`;
  // Instant naïf : on prétend que la cible est en UTC.
  const asUTC = new Date(`${target}Z`);
  // Comment Paris lit cet instant ? (sv-SE donne 'YYYY-MM-DD HH:MM:SS')
  const parisReads = new Intl.DateTimeFormat('sv-SE', {
    timeZone: PARIS,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false,
  }).format(asUTC);
  const parisAsUTC = new Date(`${parisReads.replace(' ', 'T')}Z`);
  const offsetMs = parisAsUTC.getTime() - asUTC.getTime();
  return new Date(asUTC.getTime() - offsetMs).toISOString();
}

function formatter(opts) {
  return new Intl.DateTimeFormat('fr-FR', { timeZone: PARIS, ...opts });
}

export function formatParisDateTime(value) {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return formatter({
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  }).format(d);
}

export function formatParisDate(value) {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return formatter({
    day: '2-digit', month: '2-digit', year: 'numeric',
  }).format(d);
}

export function formatParisTime(value) {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return formatter({ hour: '2-digit', minute: '2-digit' }).format(d);
}
